<!-- 资讯正文页 推广专题正文页 正文内容 组成正文内容的所有组件集合 包括所有组件 纯富文本也是一种组件 -->
<template>
  <div id="detailWidgets" class="detail-widgets-wrapper">
    <component
      :is="item.view"
      v-for="item in widgets"
      :key="item.id"
      :data="item.data"
      :pkg="pkg"
      :show-all-authority="showAllAuthority"
      :styl="styl"
    ></component>
  </div>
</template>

<script>
import WidgetRichText from './WidgetRichText'
import WidgetCaseCard from './WidgetCaseCard'
import WidgetCaseList from './WidgetCaseList'
import WidgetFileViewer from './WidgetFileViewer'
import WidgetBaiduMap from './WidgetBaiduMap'
import WidgetContactInfo from './WidgetContactInfo'
import WidgetActivityApply from './WidgetActivityApply'
import WidgetArticleCard from './WidgetArticleCard'
import ParseAndCompleteHtml from './ParseAndCompleteHtml'

export default {
  components: {
    WidgetRichText,
    WidgetCaseList,
    WidgetCaseCard,
    WidgetFileViewer,
    WidgetBaiduMap,
    WidgetContactInfo,
    WidgetActivityApply,
    WidgetArticleCard
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => ({})
    },
    pkg: {
      type: Object,
      default: () => ({})
    },
    showAllAuthority: Boolean,
    styl: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      widgets: []
    }
  },
  async fetch() {
    this.getWidgets()
    await Promise.resolve()
  },
  watch: {
    contentInfo() {
      this.getWidgets()
    }
  },
  mounted() {
    // 从正文内容中抽取每个组件需要的数据
    this.getWidgets()
  },
  methods: {
    // 从正文内容中抽取每个组件需要的数据
    getWidgets() {
      const content = this.contentInfo.body
      let widgets = []
      this.widgets = []
      // 从正文内容中提取组件数据的正则

      // 提取分割之后的纯文本内容 + 组件数据
      // 这个地方没做校验，理论上 纯文本内容数组长度 = 组件数据数组长度 + 1
      // 第一个 或者是 最后一个 纯文本内容为空，暂时不过滤，直接在纯文本内容组件内部处理

      // 更新逻辑：
      // 通过正则匹配带有widget-source属性的div（案例组件）分割内容
      // 可能会遇到嵌套标签的问题，造成有些纯文本会缺失开始标签或者结束标签
      // 纯文本会进行补齐标签处理（造成的问题：增加标签个数，原本嵌套的标签分成了前后两个标签），但不会影响显示内容
      // by yuanying 20200811

      const pattern = /<div[^>]*?widget-source=[\s\S]+?>[\s\S]*?<\/div>/g
      let arrText = content.split(pattern)
      let arrWidget = content.match(pattern)

      if (arrText && arrText.length) {
        arrText = arrText.map(item => {
          // 闭合标签
          let parseAndCompleteHtml = new ParseAndCompleteHtml(item)
          let res = parseAndCompleteHtml.completeTag()
          return res
        })
      }

      // 将组件数据还原
      if (arrWidget && arrWidget.length) {
        arrWidget = arrWidget.map(item => {
          // 获取widget-source属性值
          const widgetSourcePattern =
            /<div\s[^>]*?widget-source=["']([\s\S]+?)["'][\s\S]*?>[\s\S]*?<\/div>/
          let widgetInfo = widgetSourcePattern.exec(item)[1]
          return JSON.parse(unescape(widgetInfo))
        })
      } else {
        arrWidget = []
      }

      // 将纯文本内容 + 组件数据 合并
      // 理论上，纯文本内容，组件内容，交替
      for (let i = 0, len = arrText.length; i < len; i++) {
        // 纯文本内容
        let text = arrText[i]
        if (text) {
          widgets.push({
            id: i * 2,
            view: 'widget-rich-text',
            data: text
          })
        }
        // 组件内容
        let json = arrWidget[i]
        if (json) {
          widgets.push({
            id: i * 2 + 1,
            view: json.key,
            data: json
          })
        }
      }
      this.$nextTick(() => {
        this.widgets = widgets
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-widgets-wrapper {
  background-color: #ffffff;
  color: #363636;
}
</style>
